
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as preview5d59c0NdFJyN9ePPjQ0xh_Ke3_LpJ015GPjpKMAj53sMeta } from "/app/pages/preview.vue?macro=true";
import { default as _91_91slug_93_93on4DX_ln261ccS7cVlVj42nyDkayPKDaZP_455VWqejPkMeta } from "/app/pages/[[slug]].vue?macro=true";
import { default as indexF9AddZJrtMxm1vh0GhBdqHsaQdM0kOvMgh_wtP6QccAMeta } from "/app/pages/zona/index.vue?macro=true";
import { default as indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta } from "/app/pages/local/index.vue?macro=true";
import { default as indexEqEOBC4aycsHGz9t1NKd4oTz0Qx8W81EWaa3D4N8fo4Meta } from "/app/pages/region/index.vue?macro=true";
import { default as _91postcode_93eLW0wScnwNHmKbxQe0r7DXFti1p_O9weXEJ5FaOetDkMeta } from "/app/pages/zona/[postcode].vue?macro=true";
import { default as _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta } from "/app/pages/local/[postcode].vue?macro=true";
import { default as _91postcode_93GMz_45L5_45BDPxbq4wbea_EXRX72ITxtp9AtC7mVnNWrZkMeta } from "/app/pages/region/[postcode].vue?macro=true";
import { default as _91_91slug_93_93joS06NvP4Aeln10Cdlx2umYm6eYZKxRYj9gGQnZQWeMMeta } from "/app/pages/[[level_1]]/[[slug]].vue?macro=true";
import { default as _91_91slug_93_93dDEWOmw6D1Pie6UHCkW6Rwx4vKfZrDhIjaOl03OLgbsMeta } from "/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue?macro=true";
import { default as _91_91slug_93_93L2HVayU_4HWTa46BDSRoyyKOHpjx_oKXZA1J_45CrI4RoMeta } from "/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue?macro=true";
export default [
  {
    name: "preview___en",
    path: "/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "preview___us",
    path: "/us/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "preview___es",
    path: "/es/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "preview___fr",
    path: "/fr/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "preview___de",
    path: "/de/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "slug___en",
    path: "/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "slug___us",
    path: "/us/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "zona___en",
    path: "/zona",
    meta: indexF9AddZJrtMxm1vh0GhBdqHsaQdM0kOvMgh_wtP6QccAMeta || {},
    component: () => import("/app/pages/zona/index.vue")
  },
  {
    name: "zona___us",
    path: "/us/zona",
    meta: indexF9AddZJrtMxm1vh0GhBdqHsaQdM0kOvMgh_wtP6QccAMeta || {},
    component: () => import("/app/pages/zona/index.vue")
  },
  {
    name: "zona___es",
    path: "/es/zona",
    meta: indexF9AddZJrtMxm1vh0GhBdqHsaQdM0kOvMgh_wtP6QccAMeta || {},
    component: () => import("/app/pages/zona/index.vue")
  },
  {
    name: "zona___fr",
    path: "/fr/zona",
    meta: indexF9AddZJrtMxm1vh0GhBdqHsaQdM0kOvMgh_wtP6QccAMeta || {},
    component: () => import("/app/pages/zona/index.vue")
  },
  {
    name: "zona___de",
    path: "/de/zona",
    meta: indexF9AddZJrtMxm1vh0GhBdqHsaQdM0kOvMgh_wtP6QccAMeta || {},
    component: () => import("/app/pages/zona/index.vue")
  },
  {
    name: "local___en",
    path: "/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "local___us",
    path: "/us/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "local___es",
    path: "/es/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "local___fr",
    path: "/fr/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "local___de",
    path: "/de/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "region___en",
    path: "/region",
    meta: indexEqEOBC4aycsHGz9t1NKd4oTz0Qx8W81EWaa3D4N8fo4Meta || {},
    component: () => import("/app/pages/region/index.vue")
  },
  {
    name: "region___us",
    path: "/us/region",
    meta: indexEqEOBC4aycsHGz9t1NKd4oTz0Qx8W81EWaa3D4N8fo4Meta || {},
    component: () => import("/app/pages/region/index.vue")
  },
  {
    name: "region___es",
    path: "/es/region",
    meta: indexEqEOBC4aycsHGz9t1NKd4oTz0Qx8W81EWaa3D4N8fo4Meta || {},
    component: () => import("/app/pages/region/index.vue")
  },
  {
    name: "region___fr",
    path: "/fr/region",
    meta: indexEqEOBC4aycsHGz9t1NKd4oTz0Qx8W81EWaa3D4N8fo4Meta || {},
    component: () => import("/app/pages/region/index.vue")
  },
  {
    name: "region___de",
    path: "/de/region",
    meta: indexEqEOBC4aycsHGz9t1NKd4oTz0Qx8W81EWaa3D4N8fo4Meta || {},
    component: () => import("/app/pages/region/index.vue")
  },
  {
    name: "zona-postcode___en",
    path: "/zona/:postcode()",
    meta: _91postcode_93eLW0wScnwNHmKbxQe0r7DXFti1p_O9weXEJ5FaOetDkMeta || {},
    component: () => import("/app/pages/zona/[postcode].vue")
  },
  {
    name: "zona-postcode___us",
    path: "/us/zona/:postcode()",
    meta: _91postcode_93eLW0wScnwNHmKbxQe0r7DXFti1p_O9weXEJ5FaOetDkMeta || {},
    component: () => import("/app/pages/zona/[postcode].vue")
  },
  {
    name: "zona-postcode___es",
    path: "/es/zona/:postcode()",
    meta: _91postcode_93eLW0wScnwNHmKbxQe0r7DXFti1p_O9weXEJ5FaOetDkMeta || {},
    component: () => import("/app/pages/zona/[postcode].vue")
  },
  {
    name: "zona-postcode___fr",
    path: "/fr/zona/:postcode()",
    meta: _91postcode_93eLW0wScnwNHmKbxQe0r7DXFti1p_O9weXEJ5FaOetDkMeta || {},
    component: () => import("/app/pages/zona/[postcode].vue")
  },
  {
    name: "zona-postcode___de",
    path: "/de/zona/:postcode()",
    meta: _91postcode_93eLW0wScnwNHmKbxQe0r7DXFti1p_O9weXEJ5FaOetDkMeta || {},
    component: () => import("/app/pages/zona/[postcode].vue")
  },
  {
    name: "local-postcode___en",
    path: "/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "local-postcode___us",
    path: "/us/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "local-postcode___es",
    path: "/es/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "local-postcode___fr",
    path: "/fr/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "local-postcode___de",
    path: "/de/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "region-postcode___en",
    path: "/region/:postcode()",
    meta: _91postcode_93GMz_45L5_45BDPxbq4wbea_EXRX72ITxtp9AtC7mVnNWrZkMeta || {},
    component: () => import("/app/pages/region/[postcode].vue")
  },
  {
    name: "region-postcode___us",
    path: "/us/region/:postcode()",
    meta: _91postcode_93GMz_45L5_45BDPxbq4wbea_EXRX72ITxtp9AtC7mVnNWrZkMeta || {},
    component: () => import("/app/pages/region/[postcode].vue")
  },
  {
    name: "region-postcode___es",
    path: "/es/region/:postcode()",
    meta: _91postcode_93GMz_45L5_45BDPxbq4wbea_EXRX72ITxtp9AtC7mVnNWrZkMeta || {},
    component: () => import("/app/pages/region/[postcode].vue")
  },
  {
    name: "region-postcode___fr",
    path: "/fr/region/:postcode()",
    meta: _91postcode_93GMz_45L5_45BDPxbq4wbea_EXRX72ITxtp9AtC7mVnNWrZkMeta || {},
    component: () => import("/app/pages/region/[postcode].vue")
  },
  {
    name: "region-postcode___de",
    path: "/de/region/:postcode()",
    meta: _91postcode_93GMz_45L5_45BDPxbq4wbea_EXRX72ITxtp9AtC7mVnNWrZkMeta || {},
    component: () => import("/app/pages/region/[postcode].vue")
  },
  {
    name: "level_1-slug___en",
    path: "/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-slug___us",
    path: "/us/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-slug___es",
    path: "/es/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-slug___fr",
    path: "/fr/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-slug___de",
    path: "/de/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___en",
    path: "/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___us",
    path: "/us/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___es",
    path: "/es/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___fr",
    path: "/fr/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___de",
    path: "/de/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___en",
    path: "/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___us",
    path: "/us/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___es",
    path: "/es/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___fr",
    path: "/fr/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___de",
    path: "/de/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  }
]